/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path, Rect } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 24,
        height: 21,
        viewBox: "0 0 24 21",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Rect, {
                x: 1,
                y: 1,
                width: 21.89,
                height: 18.25,
                rx: 3,
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M8.98 8.63h1.93V7.3a1.3 1.3 0 0 0-1.28-1.32H5.77c-.71 0-1.29.6-1.29 1.32v5.31c0 .73.58 1.33 1.29 1.33h3.86c.7 0 1.28-.6 1.28-1.33v-1.33H8.98v.67H6.41V7.97h2.57z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M17.98 8.63h1.93V7.3a1.3 1.3 0 0 0-1.29-1.32h-3.85c-.72 0-1.29.6-1.29 1.32v5.31c0 .73.57 1.33 1.29 1.33h3.85c.72 0 1.29-.6 1.29-1.33v-1.33h-1.93v.67h-2.57V7.97h2.57z",
                fill: "currentColor"
            })
        ]
    }));
};
export default SvgComponent;
